import AppIcons from "../../components/Base/AppIcons";
import { lazy } from "react";
import { rutaGeneracionQRBancoW } from "../../apps/BancoW/routes.jsx";
import { routesAsignacionQrCodeQr } from "../../apps/PasarelaAsignacionQr/routes";
import { rutaGeneracionQRPortalPagos } from "../../apps/RecaudoGenericoPDP/routes";

const CodigoBarrasComercio = lazy(() => import("./views/CodigoBarrasComercio"));

export const rutasInformacionGeneral = [
  {
    link: "/info/codigo_barras_comercio",
    label: (
      <AppIcons
        Logo={"RECAUDO"}
        name="Descargar código de barras del comercio"
      />
    ),
    component: CodigoBarrasComercio,
    permission: [69],
  },
  ...routesAsignacionQrCodeQr,
  rutaGeneracionQRBancoW,
  rutaGeneracionQRPortalPagos,
];
